// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sk-c";
export var backButton = "_sk-4";
export var backIcon = "_sk-5";
export var chevronShortcut = "_sk-6";
export var container = "_sk-1";
export var editor = "_sk-8";
export var editorWrapper = "_sk-7";
export var prefix = "_sk-2";
export var searchIcon = "_sk-3";
export var suffix = "_sk-9";
export var suffixContent = "_sk-a";
export var suffixText = "_sk-b";
export var wrapper = "_sk-0";